var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70703 0.293031C5.8945 0.480558 5.99982 0.734866 5.99982 1.00003C5.99982 1.26519 5.8945 1.5195 5.70703 1.70703L2.41403 5.00003L5.70703 8.29303C5.88919 8.48163 5.98998 8.73423 5.9877 8.99643C5.98543 9.25863 5.88026 9.50944 5.69485 9.69485C5.50944 9.88026 5.25863 9.98543 4.99643 9.9877C4.73423 9.98998 4.48163 9.88919 4.29303 9.70703L0.293031 5.70703C0.10556 5.5195 0.000244141 5.26519 0.000244141 5.00003C0.000244141 4.73487 0.10556 4.48056 0.293031 4.29303L4.29303 0.293031C4.48056 0.10556 4.73487 0.000244141 5.00003 0.000244141C5.26519 0.000244141 5.5195 0.10556 5.70703 0.293031Z",
    fill: "#9CA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev-icon.f5baac65cff4b22ade0066a12fc042f2.svg";
export { ForwardRef as ReactComponent };